import { render, staticRenderFns } from "./website-web-service-detail.vue?vue&type=template&id=de2df36e&scoped=true&"
import script from "./website-web-service-detail.vue?vue&type=script&lang=js&"
export * from "./website-web-service-detail.vue?vue&type=script&lang=js&"
import style0 from "./website-web-service-detail.vue?vue&type=style&index=0&id=de2df36e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2df36e",
  null
  
)

export default component.exports